import React, { ForwardRefRenderFunction, forwardRef } from 'react'
import cx from 'classnames'
import './Header.scss'
import { HeaderProps } from "./Header.types";

const Header: ForwardRefRenderFunction<HTMLDivElement, HeaderProps> = (props, ref) => {
  const {
    className = null,
    fill = false,
    fixed = false,
    hasBorder = false,
    highlighted = false,
    topOffset = null,
    children,
    logoUrl,
    altText,
    text,
    childClasses
  } = props

  

  const classes = cx(className, 
                     hasBorder, 
                     {'header-fixed': fixed}, 
                     {'header-fill':fill}, 
                     {'header-highlighted':highlighted});

  const styling = () => {
    if (topOffset) {
      return { top: `${topOffset}px` }
    }
    return null
  }

  return (
    <div  className={classes} ref={ref} style={styling()}>
      <img src={logoUrl} alt={altText} />
      {text ? text : null}
      {children 
      ? <div className={childClasses}> {children} </div> 
      : null}
    </div>
  )
}

export default forwardRef(Header)
